import * as React from 'react';
import { connect } from 'react-redux';
import { Route, Switch } from 'react-router';
import Layout from './../Layout';
import SharedMaterialsHome from './SharedMaterialsHome';
import SharedMaterialSupplier from './SharedMaterialSupplier';
import SharedMaterialDetail from './Detail/SharedMaterialDetail';
import RequestAccessToSharedMaterial from './RequestAccessToSharedMaterials';
import ContactSupplier from './ContactSupplier';
import ShareMaterial from './ShareMaterial';
import { ApplicationState } from '../../store';
import { ToxnotReactComponentPaths } from '../core/ToxnotReactComponentPaths';
import * as SharedMaterialsDatabaseStateController from '../../store/StateControllers/SharedMaterials/SharedMaterialsDatabaseStateController';
import StaticPageReloader from '../StaticPageReloader';
import { ToxnotComponent, ToxnotComponentProperties } from '../core/BaseApplicationComponents/ToxnotComponent';
import { LoadingSpinner, LoadingSpinnerSize } from '../core/LoadingSpinner';

type SharedMaterialsDatabaseProps =
    SharedMaterialsDatabaseStateController.SharedMaterialsState &
    ToxnotComponentProperties &
    typeof SharedMaterialsDatabaseStateController.actionCreators;

class SharedMaterialsDatabase extends ToxnotComponent<SharedMaterialsDatabaseProps> {
    // ===============================================================================

    public componentDidMount() {
       
    }

    // ===============================================================================

    public render() {
        return (
            <Switch>
                <Route exact={true} path={ToxnotReactComponentPaths.SharedMaterialSupplier}>
                    <Layout options={{ pinAppContentToWindowHeight: true }}>
                        <Route exact={true} path={ToxnotReactComponentPaths.SharedMaterialSupplier} component={SharedMaterialSupplier} />
                    </Layout>
                </Route>
                <Route exact={false} path={ToxnotReactComponentPaths.BaseSharedMaterialsDatabasePath}>
                    <Layout>
                        <Switch>
                            <Route exact={true} path={ToxnotReactComponentPaths.SharedMaterialBaseDetailPath + '/:sharedMaterialId'} component={SharedMaterialDetail} />
                            <Route exact={true} path={ToxnotReactComponentPaths.RequestAccessToSharedMaterial} component={RequestAccessToSharedMaterial} />
                            <Route exact={true} path={ToxnotReactComponentPaths.ContactSupplier + '/:companyId/:sharedMaterialId?'} component={ContactSupplier} />
                            <Route exact={true} path={ToxnotReactComponentPaths.ShareMaterial + '/:sharedMaterialId'} component={ShareMaterial} />
                            <Route component={StaticPageReloader} />
                        </Switch>
                    </Layout>
                </Route>
                <Route exact={false} path={ToxnotReactComponentPaths.BaseSharedMaterialsPath}>
                    <Layout options={{ pinAppContentToWindowHeight: true }}>
                        <SharedMaterialsHome />
                    </Layout>
                </Route>
            </Switch>
        );
    }
}

// ===============================================================================

export default connect(
    (state: ApplicationState) => ({ ...state.sharedMaterialsState, appServices: state.appServices }),
    SharedMaterialsDatabaseStateController.actionCreators // Selects which action creators are merged into the component's props
)(SharedMaterialsDatabase as any);
